import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 44 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ eyebrow, eyebrowAr, title, dark = false, testId }) => (
  <div className="mb-14 md:mb-20">
    <FadeUp>
      <span className="flex items-center gap-4">
        <span
          dir="ltr"
          className={`font-display text-xs md:text-sm tracking-[0.35em] ${
            dark ? "text-copper" : "text-petrol"
          }`}
        >
          {eyebrow}
        </span>
        <span className={`h-px w-8 ${dark ? "bg-copper/60" : "bg-petrol/40"}`} aria-hidden="true" />
        <span className={`font-head text-xs md:text-sm font-bold ${dark ? "text-copper" : "text-petrol"}`}>
          {eyebrowAr}
        </span>
      </span>
    </FadeUp>
    <FadeUp delay={0.1}>
      <h2
        data-testid={testId}
        className={`mt-4 font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.2] ${
          dark ? "text-cream" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </FadeUp>
    <motion.div
      className="rule-copper mt-8 w-40"
      initial={{ scaleX: 0, transformOrigin: "right" }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.2, delay: 0.25, ease: EASE }}
    />
  </div>
);
